export const StoreSettings = {
  usePlanningToolRecommendationOnImport: {
    key: 'usePlanningToolRecommendationOnImport',
  },
  EnhancedReturnsActivationStatus: { key: 'EnhancedReturnsActivationStatus' },
};

export const StoreSettingsGroupings = {
  settings: { key: 'settings' },
};
